<template>
  <div class="col-12 col-md-6 col-xl-4">
    <div class="no-user-card">
      <div class="no-user-image" @click="showInviteModal">
        <span v-if="loggedInUser.role == 1">+</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InviteModal from '@/components/shared/modals/InviteModal';

export default {
  name: 'NoUserCard',
  computed: {
    ...mapGetters({
      loggedInUser: 'users/loggedInUserProfile',
    }),
  },
  methods: {
    showInviteModal() {
      if (this.loggedInUser.role !== 1) {
        return;
      }
      this.$eventBus.showModal({
        bind: {
          is: InviteModal,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.no-user-card {
  background-color: rgba(250, 250, 250, 1);
  border: 2px dashed #ccc;
  border-radius: 8px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  display: inline-block;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  margin: 20px;
  margin-top: 20px;
  padding: 20px;
  .no-user-image {
    width: 100px;
    height: 100px;
    border: 2px dashed #ccc;
    background-color: #eee;
    border-radius: 50px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      display: none;
      cursor: pointer;
      color: #ccc;
      font-size: 60px;
    }
  }
  &:hover {
    span {
      display: inline-block;
    }
  }
}
</style>
